module.exports = __webpack_public_path__ + "static/media/message-square.36a3c078.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/profile/tabs/HomeTab/resources/message-square.svg
// module id = 3481
// module chunks = 0